/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.OMS {
    import fld = ProductInspectionRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ProductInspectionEditor extends _Ext.ItemGridEditor<ProductInspectionRow> {
        protected getColumnsKey() { return "OMS.ProductInspection"; }
        protected getDialogType() { return ProductInspectionDialog; }
        protected getLocalTextPrefix() { return ProductInspectionRow.localTextPrefix; }
       
        constructor(container: JQuery) {
            super(container); 
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//
            buttons.push({
                title: "Select QC",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.QualityInspectionSelectGrid;
                    // **** Validate Party before Item Selection ****  
                    var filters: _Ext.SelectGridFilters = {

                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select QC"
                    });

                    pickerDialog.onSuccess = (selectedItems: Administration.QualityInspectionTemplateRow[]) => {
                        let selectedItems2 = selectedItems[0];
                        this.view.setItems([]);
                        for (var i = 0; i < selectedItems2.Details.length; i++) {
                            var qc = selectedItems2.Details[i];
                            var newqc: ProductInspectionRow = {
                                IsNumeric: qc.IsNumeric,
                                Max: qc.Max,
                                Min: qc.Min,
                                Value: qc.Value,
                                Parameter: qc.Parameter,
                                TemplateId: qc.TemplateId
                            }
                            newqc[this.getIdProperty()] = "`" + this.nextId++; 
                                this.view.addItem(newqc);
                        }
                    }

                    pickerDialog.dialogOpen();
                },
            });
            return buttons;
        } 
     
    }
}